import React, { useCallback } from 'react';
import { styled } from '@compiled/react';
import { Text } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { InProductHelpLink } from '@atlassian/jira-servicedesk-common/src/ui/components/in-product-help-link';
import { messages } from './messages';

export const NotificationAppSubHeader = () => {
	const { formatMessage } = useIntl();
	const articleId = '3VlB3YNCvdJ8c8zzo50d85';
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const onLearnMoreLinkClicked = useCallback(
		() =>
			fireUIAnalytics(
				createAnalyticsEvent({
					actionSubject: 'learnMoreAboutCustomerNotificationLogsLink',
					action: 'clicked',
				}),
				'learnMoreAboutCustomerNotificationLogs',
			),
		[createAnalyticsEvent],
	);
	return (
		<SubHeaderContainer>
			<Text>
				{formatMessage(messages.knowMoreInfoText)}
				<InProductHelpLink
					href=""
					inProductHelpArticleId={articleId}
					learnMoreText={formatMessage(messages.learnMoreText)}
					onClick={onLearnMoreLinkClicked}
				/>
			</Text>
		</SubHeaderContainer>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SubHeaderContainer = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	p: {
		display: 'inline',
		marginRight: token('space.100', '8px'),
	},
});
